import React from 'react'
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const FloatButton = () => {
  return (
      <div>

<a href="https://api.whatsapp.com/send?phone=+525615660268&text=Hola%21%20Quisiera%20m%C3%A1s%20informaci%C3%B3n%20sobre%20BarmanBoys%20." class="float" target="_blank">
<i><WhatsAppIcon sx={{ fontSize: 40 }}  /></i>
</a>
</div>
  )
}

export default FloatButton